import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class AdditionalWaiverIdsService {

  constructor(private http: HttpClient) { }

  getListByHorseShow(horse_show_id: string): Promise<any[]> {
  return this.getListWithRest('horse_show_id/' + horse_show_id);
  }

  private getListWithRest(rest_url: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'additional_waiver_ids/' + rest_url).subscribe((response:any) => {
      if(response.type == 'waiver_ids' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error => {
        if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
      });
  });
  }


}
